import { TableCell, TableRow, Link } from '@mui/material';
import React, { useContext } from 'react';
import { UserContext } from '../../Hooks/useUser';
import { useNavigate } from 'react-router';
import { NumericFormat } from 'react-number-format';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CopyButton from '../../CustomComponents/CopyButton';
import { TrendingUp } from '@mui/icons-material';

function InventoryRow(props) {
    const { hasInventoryManagement, user } = useContext(UserContext);
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));

    function goToItem(item) {
        if (hasInventoryManagement()) {
            navigate(`/inventory/${item.id}/details`);
        }
    }

    function goToItemTrends(event, item) {
        event.stopPropagation(); // Prevent row click
        navigate(`/organizations/${user.hospital.organization_id}/items/${item.id}/itemAnalytics`);
    }

    return (
        <TableRow onClick={() => goToItem(props.item)} hover sx={{
            cursor: 'pointer',

            ...(isSmScreen && {
                '& > td:nth-child(1)': { width: '35%' },
                '& > td:nth-child(2)': { width: '12%' },
                '& > td:nth-child(3)': { width: '8%' },
                '& > td:nth-child(4)': { width: '8%' },
                '& > td:nth-child(5)': { width: '12%' },
                '& > td:nth-child(6)': { width: '8%' },
                '& > td:nth-child(7)': { width: '7%' },
                '& > td:nth-child(8)': { width: '10%' },
            }),
        }}>
            <TableCell>{props.item.name}</TableCell>
            <TableCell>{props.item.vendor.name}</TableCell>
            <TableCell>{props.item.part_number}</TableCell>
            <TableCell>{props.item.external_id}<CopyButton textToCopy={props.item.external_id} /></TableCell>
            <TableCell>{props.item.category}</TableCell>
            <TableCell>
                <NumericFormat
                    value={props.item.cost / 100}
                    thousandSeparator={true}
                    displayType={'text'}
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                />
            </TableCell>
            <TableCell>{props.item.is_active ? 'Active' : 'Inactive'}</TableCell>
            <TableCell>
                <Link
                    onClick={(event) => goToItemTrends(event, props.item)}
                    sx={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        color: 'primary.main',
                        textDecoration: 'none',
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    <TrendingUp fontSize="small" />
                    Trends
                </Link>
            </TableCell>
        </TableRow>
    );
}

export default InventoryRow;
